import { PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { saveAs } from "file-saver";

const TEMPLATE_URL = process.env.PUBLIC_URL + "/AETR/AETRPotvrda.pdf";
const FONT_URL = process.env.PUBLIC_URL + "/AETR/LiberationSans-Regular.ttf";

const FIELD_PREFIX = "topmostSubform[0].Page1[0].";

// Mapa polja u praznom AETR PDF obrascu (utvrđeno poređenjem pozicija
// labela i polja unutar samog PDF-a — obrazac nema imena polja po smislu).
const FIELD_MAP = {
  firmaNaziv: "TextField1[0]",
  firmaAdresa: "TextField1[1]",
  firmaDrzava: "TextField1[2]",
  firmaFax: "TextField1[3]",
  firmaEmail: "TextField1[4]",
  direktorIme: "TextField1[5]",
  direktorPozicija: "TextField1[6]",
  vozacIme: "TextField1[7]",
  vozacRodjen: "TextField1[8]",
  licenca: "TextField1[9]",
  datumZaposlenja: "TextField1[10]",
  vremeOd: "TextField1[11]",
  vremeDo: "TextField1[12]",
  firmaTelefon: "TextField1[19]",
  mestoRow20: "TextField1[18]",
  datumRow20: "TextField1[13]",
  mestoRow22En: "TextField1[14]",
  datumRow22En: "TextField1[15]",
  mestoRow22Sr: "TextField1[16]",
  datumRow22Sr: "TextField1[17]",
};

// CheckBoxN u obrascu ide obrnutim redosledom od tipPozicija (1=bolovanje ... 6=raspoloživ)
const checkboxForTipPozicija = (tipPozicija) => {
  const n = Number(tipPozicija);
  if (!n || n < 1 || n > 6) return null;
  return `CheckBox${7 - n}[0]`;
};

function licencaTekst(podaci) {
  return `Br.Voz.doz.: ${podaci.vozacVD || "/"}  Br.LK: ${podaci.vozacLK || "/"}  Br.pasoša: ${podaci.vozacPasos || "/"}`;
}

async function fetchBytes(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Ne mogu da preuzmem fajl: ${url}`);
  return await res.arrayBuffer();
}

export async function exportAetrPotvrdaPdf(id, token, fileName = "AETR_Potvrda.pdf") {
  const res = await fetch(process.env.REACT_APP_BACKEND_URL + "/employees/AETR/print", {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
    body: JSON.stringify({ id }),
  });
  if (!res.ok) throw new Error("Ne mogu da preuzmem podatke za AETR potvrdu.");
  const podaci = await res.json();

  const [templateBytes, fontBytes] = await Promise.all([
    fetchBytes(TEMPLATE_URL),
    fetchBytes(FONT_URL),
  ]);

  const pdfDoc = await PDFDocument.load(templateBytes);
  pdfDoc.registerFontkit(fontkit);
  const font = await pdfDoc.embedFont(fontBytes, { subset: true });

  const form = pdfDoc.getForm();

  const values = {
    ...podaci,
    licenca: licencaTekst(podaci),
    mestoRow20: podaci.mesto,
    datumRow20: podaci.datumStampe,
    mestoRow22En: podaci.mesto,
    datumRow22En: podaci.datumStampe,
    mestoRow22Sr: podaci.mesto,
    datumRow22Sr: podaci.datumStampe,
  };

  for (const [key, fieldSuffix] of Object.entries(FIELD_MAP)) {
    const field = form.getTextField(FIELD_PREFIX + fieldSuffix);
    field.setText(values[key] || "");
  }

  const checkboxName = checkboxForTipPozicija(podaci.tipPozicija);
  if (checkboxName) {
    form.getCheckBox(FIELD_PREFIX + checkboxName).check();
  }

  form.updateFieldAppearances(font);

  const pdfBytes = await pdfDoc.save();
  saveAs(new Blob([pdfBytes], { type: "application/pdf" }), fileName);
}
